exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tf_title_dialog[data-v-28c02b74] {\n  text-overflow: ellipsis;\n  width: calc(100% - 100px);\n  overflow: hidden;\n  white-space: nowrap;\n}\n.compare-col[data-v-28c02b74] {\n  margin-bottom: 12px;\n}\n.compare-body[data-v-28c02b74] {\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n}\n.compare-body .layout[data-v-28c02b74] {\n  margin-left: 0;\n  margin-right: 0;\n}\n.compare-body .flex[data-v-28c02b74] {\n  padding-left: 0;\n  padding-right: 0;\n}\n.compare-label[data-v-28c02b74] {\n  margin-left: 0;\n}\n.compare-title[data-v-28c02b74] {\n  -ms-flex-align: center;\n      align-items: center;\n}\n.compare-title-text[data-v-28c02b74] {\n  line-height: 1.2;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-28c02b74","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheezy/WzDialogEnhancePrompt.vue
// module id = YiLw
// module chunks = 1